import { WizardMethodsType } from '@pe-libs/react-components/build/components/PeFormWizard/types';
import PeStepper from '@pe-libs/react-components/build/components/PeStepper';
import React, { useMemo, useEffect, FC } from 'react';

type Props = WizardMethodsType & {
  actions: {
    setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  };
};

const PeOnboardingStepper: FC<Props> = ({ page, pages, actions }) => {
  const steps = useMemo(() => Array.from({ length: pages }, (_, index) => ({ elementId: `step${index}` })), [pages]);

  useEffect(() => {
    actions.setCurrentStep(page + 1);
  }, [page, actions]);

  return <PeStepper steps={steps} activeStep={page} />;
};

export default PeOnboardingStepper;
